import React from 'react';
import { _clientSettings } from '../../config/client-settings';
import { AccountInfo, AuthenticationResult, IPublicClientApplication, PopupRequest } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

export const _loginRequest: PopupRequest = {
    scopes: [
        `api://${_clientSettings.clientId}/user_impersonation`, //for obo authentication
        "offline_access" //for refresh token
    ]
};

export const aquireToken = async (instance: IPublicClientApplication): Promise<AuthenticationResult> => {
    const account: AccountInfo = instance.getActiveAccount();

    if (!account)
        throw Error("No active account!");

    return await instance.acquireTokenSilent({
        ..._loginRequest,
        account: account
    });
};

export const AuthContext = React.createContext(null);

export const AuthProvider = (props) => {
    const { instance } = useMsal();

    const logOut = () => {
        instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
    };

    const { Provider } = AuthContext;

    return (
        <Provider value={{ logOut }}>
            {props.children}
        </Provider>
    );
};